module.exports = __webpack_public_path__ + "img/icon_location_1.99540b3d.svg";